import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const scriptUiNodeSpec: NodeSpec<NodeCfg<'script'>> = {
    requiredSockets: [ 'trigger' ],
    cfg: () => ({ controlValues: { scriptId: '' }, id: getUID(), kind: 'script', disabled: false, width: 200 }),
    controls: nodeCfg => ({
        scriptId: defineControlOpts({
            cfg: { kind: 'scriptSelect', label: 'Script' },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.scriptId,
        }),
    }),
    inputs: () => ({ trigger: { socket: 'event', label: 'Trigger' } }),
    kindLabel: 'Script',
    nodeCategory: 'other',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: (node, appletDesignVersionConfig) => {
        const validScriptIds = appletDesignVersionConfig.scripts.map(script => script.id);
        const errors: Record<string, string> = {};
        if (!node.controlValues.scriptId) {
            errors.scriptId = 'Script is required';
        } else if (!validScriptIds.includes(node.controlValues.scriptId)) {
            errors.scriptId = 'Script is not a valid script';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
